// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2ps9n","paramInput":"JobSimulator_paramInput__2pDsg","input":"JobSimulator_input__WqE7i"};